export enum PLG_EVENTS {
  DEVELOPER_HUB_BUTTON = 'DEVELOPER_HUB_BUTTON',
  DEVELOPER_HUB_LINK = 'DEVELOPER_HUB_LINK',
  GET_STARTED_LINK = 'GET_STARTED_LINK',
  GET_STARTED_BUTTON = 'GET_STARTED_BUTTON',
  SAMPLE_APPS_LINK = 'SAMPLE_APPLICATION_LINK',
}
